export class EntStockFilter {
	warehouseId: number | null = null
	companyId: number | null = null
	reportingYear: number | null = null
	fertilizerIds: number[] | null = null
	page: number = 1
	size: number = 30
	deleted: boolean = false
}
